module.exports = function () {
    const memberItems = document.querySelectorAll(".member-item");
    if ( !memberItems.length ) return;

    for (const memberItem of memberItems) {
        const popup = memberItem.querySelector(".member-popup");
        if ( !popup ) return;
        
        const popupContent = popup.querySelector(".member-popup-content");
        const box = memberItem.querySelector(".member-item-box");
        const closeBtn = popup.querySelector(".member-popup__close");
        
        box.addEventListener("click", openPopup);
        
        function openPopup() {
            popup.classList.remove("invisible");
            document.body.classList.add("overflow-hidden");
            closeBtn.addEventListener("click", () => {
                setTimeout(() => closePopup());
            });
       
            setTimeout(() => {
                document.addEventListener("click", closeOutSide);
            })
        }
        
        function closePopup() {
            popup.classList.add("invisible");
            document.body.classList.remove("overflow-hidden");
            document.removeEventListener("click", closeOutSide);
            closeBtn.removeEventListener("click", closePopup);
        }
        
        function closeOutSide(e) {
            if ( !popupContent.contains(e.target) ) closePopup();
        }
    }
}